import React, { Component } from 'react'
import qs from 'qs'
import _ from 'lodash'

import { assets, translations } from '../../../config'
import P from '../../../components/P'
import sdk from '../../../digitalStoreSdk'

import style from './style'

const invalidTokenError = new Error('Invalid token.')

class UnsubscribeScreen extends Component {
  state = {
    status: 'LOADING'
  }

  getQueryParams = () => {
    const queryString = _.get(this.props, 'location.search', '').slice(1)
    const { customerId, token } = qs.parse(queryString)
    return { customerId, token }
  }

  validateToken = () => {
    const { customerId, token } = this.getQueryParams()

    return sdk.customers
      .validateCustomerToken({ token })
      .then(tokenResult => {
        if (
          tokenResult.customerId === customerId &&
          tokenResult.tokenType === 'unsubscribe'
        ) {
          return tokenResult
        } else {
          throw new Error()
        }
      })
      .catch(error => {
        console.error(error)
        throw invalidTokenError
      })
  }

  unsubscribe = () => {
    const { customerId, token } = this.getQueryParams()
    const updates = {
      emailMarketing: false,
      generalMarketing: false
    }

    return sdk.customers
      .unsubscribe({ token, customerId, updates })
  }

  componentDidMount () {
    // on mount:
    // check that token is valid
    // if it is, unsubscribe
    // if anything goes wrong, show error message

    this
      .validateToken()
      .then(() => {
        return this.unsubscribe()
          .then(() => {
            this.setState({ status: 'UNSUBSCRIBED' })
          })
      })
      .catch(error => {
        if (error === invalidTokenError) {
          this.setState({ status: 'INVALID_TOKEN' })
        } else {
          this.setState({ status: 'ERROR' })
        }
      })
  }

  render () {
    const { status } = this.state
    return (
      <div style={style.container}>
        <div style={style.logoContainer}>
          <img src={assets.logo} style={style.logo} />
        </div>
        <div style={style.messageContainer}>
          <P value={translations(`UNSUBSCRIBE_${status}`)} />
        </div>
      </div>
    )
  }
}

export default UnsubscribeScreen



// WEBPACK FOOTER //
// ./src/containers/Unsubscribe/UnsubscribeScreen/UnsubscribeScreen.js